module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "app-body app flex-row align-items-center"
  }, [_c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('loading', {
    attrs: {
      "message": "Аларм План запускается..."
    }
  })], 1)])])])]) : _c('div', {
    staticClass: "app"
  }, [(_vm.$route.meta.isIframe) ? [_c('div', {
    staticClass: "app-body m-0 mt-2"
  }, [_c('main', {
    staticClass: "main m-0"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)])])] : [_c('AppHeader'), _vm._v(" "), _c('div', {
    staticClass: "app-body"
  }, [_c('Sidebar'), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('AppFooter')], _vm._v(" "), _c('ModalCloseOrder'), _vm._v(" "), _c('ModalCancelOrder'), _vm._v(" "), _c('ModalProblemOrder'), _vm._v(" "), _c('ModalTransitionOrderConfirm'), _vm._v(" "), _c('ModalEditOrder'), _vm._v(" "), _c('ModalAdminAddUser'), _vm._v(" "), _c('ModalAdminAddEditCity'), _vm._v(" "), _c('ModalAdminAddEditCompany'), _vm._v(" "), _c('ModalAdminAddEditRole'), _vm._v(" "), _c('ModalAdminAddEditVirtualNumber'), _vm._v(" "), _c('ModalsOrdersStatisticParams'), _vm._v(" "), _c('ModalAdminAddEditInternalNumber'), _vm._v(" "), _c('ModalUpdatePage')], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5d6add1c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-5d6add1c"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 1043
// module chunks = 1